import { DialogService } from '@progress/kendo-angular-dialog';
import { Injectable } from '@angular/core';
import { NgbActiveModal, NgbModal, ModalDismissReasons,NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

@Injectable()
export class MessageBox  {
      constructor( private _dialogService: DialogService,private readonly _modalService: NgbModal) { }

      public open(message:string): void {
        this._dialogService.open({
            title: 'System Message',
            content:message
        });
      }

      public openCustoModal(modal:any):any{
        return this._modalService.open(modal, { 
          backdrop: 'static', 
          animation: true,
          centered: true,  });
      }
      public openSMoModal(modal:any):any{
        return this._modalService.open(modal, { backdrop: "static", size: 'lg' });
      }

      public openLargeCustoModal(modal:any):any{
        return this._modalService.open(modal, { backdrop: "static",  
          animation: true,
          windowClass: 'dark-modal', 
          size: 'xl'});
      }
}